import React, { useEffect, useState } from 'react';
import Doctor from '../Doctor/Doctor';
import './Doctors.css'

const Doctors = () => {
  const[doctors, setDoctors]= useState([])
  useEffect(()=>{
      fetch('./fakeDataDoctor.json')
      .then(res=> res.json())
      .then(data=> setDoctors(data))
  },[])
    return (
        <div className="container mt-5 pt-5">
            <h3>doctors length: {doctors.length} </h3>
           
            
                {
                    doctors.map(doctor=><Doctor doctor={doctor}></Doctor>)
                }
             </div>
        
    );
};

export default Doctors;